import { styled } from '@mui/material';
import { colors } from '../../styles';

export const NavigationItem = styled('span')`
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  color: ${props => props.color};

  &:hover {
    color: ${() => {
      // return 'rgba(34, 34, 34, 0.8)';
      return colors.blue;
    }};
  }
`;
